import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, Button, Row, Col, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import ContainerApFacturacion from "./ContainerApFacturacion";
import Select from "react-select";
import { useToasts } from 'react-toast-notifications';
import { useLocation, useHistory } from 'react-router-dom';
import {
  urlDescargaPlantillaAP,
  urlListarAseguradosAP,
  urlObtieneTipoPagoAP,
  urlObtenerPlanesAP,
  urlObtenerPagadoresAP,
  urlCargarAseguradosExcelAP,
  urlCreaFacturacionAP,
  urlEditaAseguradoAP,
  urlEliminaAseguradoAP,
} from "../../constants/urls";
import { useUploadPlantilla } from "./useUploadPlantilla";
import FormularioAsegurado from "./FormularioAsegurados";

/* ================= Estilos ================= */
const tableHeaderStyle = {
  backgroundColor: "#001871",
  color: "white",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "14px"
};

const buttonStyle = {
  backgroundColor: "#001871",
  color: "white",
  border: "none"
};

/* ================= Helpers sin optional chaining / nullish ================= */
function safeGet() {
  for (var i = 0; i < arguments.length; i++) {
    var v = arguments[i];
    if (v !== undefined && v !== null && v !== '') return v;
  }
  return '';
}
function get(obj, pathArr, fallback) {
  var cur = obj;
  for (var i = 0; i < pathArr.length; i++) {
    if (!cur || typeof cur !== 'object') return fallback;
    cur = cur[pathArr[i]];
  }
  return (cur === undefined || cur === null) ? fallback : cur;
}
function normalizeCodigo(input) {
  if (input === undefined || input === null) return '';
  var t = typeof input;
  if (t === 'string' || t === 'number') return String(input);
  if (t === 'object') {
    var v = safeGet(input.codigo, input.value, input._id);
    return v !== '' ? String(v) : '';
  }
  return '';
}
function toLowerSafe(v) {
  return (v === undefined || v === null) ? '' : String(v).toLowerCase();
}

/* ================= Componente ================= */
const ComponentApFacturacionVidas = (props) => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const [loading, setLoading] = useState(false);
  const [tipoPago, setTipoPago] = useState({});
  const [formasPago, setFormasPago] = useState([]);
  const [formaPago, setFormaPago] = useState({});
  const [numeroAsegurados, setNumeroAsegurados] = useState(0);
  const [blanket, setBlanket] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);         // Alta
  const [modalEditOpen, setModalEditOpen] = useState(false); // Edición
  const [aseguradoEditDefaults, setAseguradoEditDefaults] = useState(null);
  const [aseguradoEditId, setAseguradoEditId] = useState('');

  // Modal de Códigos (nuevo)
  const [codigosModalOpen, setCodigosModalOpen] = useState(false);
  const [filtroPlan, setFiltroPlan] = useState('');
  const [filtroPagador, setFiltroPagador] = useState('');

  const [cargaAsegurados, setCargaAsegurados] = useState(false);
  const [asegurados, setAsegurados] = useState([]);
  const [urlPlantilla, setUrlPlantilla] = useState("");

  const [planes, setPlanes] = useState([]);      // array de planes (con codigo, nombre, etc)
  const [pagadores, setPagadores] = useState([]) // array de pagadores/contratantes

  const { addToast } = useToasts();
  const fileInputRef = useRef(null);
  const { subirPlantilla, resultadoCarga, cerrarResultado } = useUploadPlantilla(id, setLoading, setCargaAsegurados);

  /* ================= Handlers UI generales ================= */
  const handleButtonClick = () => {
    if (fileInputRef && fileInputRef.current) fileInputRef.current.click();
  };

  const handleAgregarAsegurado = (nuevoAsegurado) => {
    guardaAsegurado(nuevoAsegurado);
    setModalOpen(false);
  };

  const handleEditarAsegurado = (datosActualizados) => {
    editarAsegurado(aseguradoEditId, datosActualizados);
    setModalEditOpen(false);
  };

  // Abrir modal de códigos en lugar de descargar directamente
  function abrirModalCodigos() {
    if (!urlPlantilla) {
      addToast('No hay plantilla disponible para descargar.', { appearance: 'warning' });
      return;
    }
    setCodigosModalOpen(true);
  }
  function descargarPlantilla() {
    if (urlPlantilla) {
      window.open(urlPlantilla, '_blank');
    } else {
      addToast('No hay plantilla disponible para descargar.', { appearance: 'warning' });
    }
  }

  /* ================= Effects ================= */
  useEffect(function () {
    if (!id) {
      history.push('/lista-cotizadores');
    }
  }, [id, history]);

  useEffect(function () {
    if (cargaAsegurados) {
      listarAsegurados();
    }
  }, [cargaAsegurados]);

  useEffect(function () {
    setLoading(true);
    recuperarFormaPago();
    generaPlantilla();
    listarAsegurados();
    recuperarPlanes();
    recuperarPagadores();
    setLoading(false);
  }, []);

  /* ================= Fetchers ================= */
  const recuperarPlanes = async () => {
    window.scrollTo(0, 0);
    setLoading(true);
    var url = "" + urlObtenerPlanesAP;
    var body = { id: id };
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' });
      const json = await response.json();
      if (json && json.transaccion) {
        setPlanes(Array.isArray(json.planesUnificados) ? json.planesUnificados : []);
      }
      setLoading(false);
    } catch (error) {
      addToast('Error, recuperar Planes', { appearance: 'error' });
      setLoading(false);
    }
  };

  const recuperarPagadores = async () => {
    window.scrollTo(0, 0);
    setLoading(true);
    var url = "" + urlObtenerPagadoresAP;
    var body = { id: id };
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' });
      const json = await response.json();
      if (json && json.transaccion) {
        setPagadores(Array.isArray(json.pagadores) ? json.pagadores : []);
      }
      setLoading(false);
    } catch (error) {
      addToast('Error, recuperar Planes', { appearance: 'error' });
      setLoading(false);
    }
  };

  const recuperarFormaPago = async () => {
    window.scrollTo(0, 0);
    setLoading(true);
    var url = "" + urlObtieneTipoPagoAP;
    var body = { id: id };
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' });
      const json = await response.json();
      if (json && json.transaccion) {
        setBlanket(!!json.blanket);
        setTipoPago(json.tipo_pago || {});
        setFormasPago(Array.isArray(json.catalogo_formas_pago) ? json.catalogo_formas_pago : []);
        setFormaPago(json.forma_pago ? json.forma_pago : (Array.isArray(json.catalogo_formas_pago) && json.catalogo_formas_pago.length > 0 ? json.catalogo_formas_pago[0] : {}));
        setNumeroAsegurados(parseInt(json.numAsegurados || 0, 10));
      }
      setLoading(false);
    } catch (error) {
      addToast('Error, Recuperar Formas de Pago', { appearance: 'error' });
      setLoading(false);
    }
  };

  const generaPlantilla = async () => {
    window.scrollTo(0, 0);
    setLoading(true);
    var url = "" + urlDescargaPlantillaAP;
    var body = { id: id };
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' });
      const json = await response.json();
      if (json && json.transaccion) {
        setUrlPlantilla(json.urlPlantilla || "");
      } else {
        addToast('Error ' + (json && json.mensaje ? json.mensaje : ''), { appearance: 'error' });
      }
      setLoading(false);
    } catch (error) {
      addToast('Error, Generar Plantilla', { appearance: 'error' });
      setLoading(false);
    }
  };

  const guardarDatosVidas = async () => {
    window.scrollTo(0, 0);
    setLoading(true);

    // ✅ Validación: si NO es blanket y no hay asegurados, no continuar
    if (!blanket) {
      if (!Array.isArray(asegurados) || asegurados.length === 0) {
        addToast('Debe agregar al menos un asegurado para continuar.', { appearance: 'warning' });
        setLoading(false);
        return;
      }
    } else {
      // ✅ Si ES blanket, validar que el número sea estrictamente mayor a 0 y no este vacío
      let numAs = parseInt(numeroAsegurados, 10);
      if (isNaN(numAs) || numAs <= 0) {
        addToast('El número de asegurados debe ser mayor a 0.', { appearance: 'warning' });
        setLoading(false);
        return;
      }
    }

    var url = "" + urlCreaFacturacionAP;
    var body = {
      "idCarrito": id,
      "pasoCarrito": "vidas",
      "forma_pago": formaPago,
      "num_asegurados": String(numeroAsegurados || '')
    };

    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' });
      const json = await response.json();
      if (json && json.transaccion) {
        addToast(json.mensaje || 'Guardado', { appearance: 'success' });
        props.history.push({
          pathname: props.datosCotizador.urlSiguiente,
          search: "?id=" + id
        });
      } else {
        addToast(json && json.mensaje ? json.mensaje : 'Error al guardar', { appearance: 'error' });
      }
      setLoading(false);
    } catch (error) {
      addToast('Error, Guardar Datos Vidas', { appearance: 'error' });
      setLoading(false);
    }
  };


  const listarAsegurados = async () => {
    window.scrollTo(0, 0);
    setLoading(true);
    var url = "" + (urlListarAseguradosAP + id);
    try {
      const response = await fetch(url, { method: 'GET' });
      const json = await response.json();
      if (json && json.transaccion) {
        setAsegurados(Array.isArray(json.asegurados) ? json.asegurados : []);
        setCargaAsegurados(false);
        setNumeroAsegurados(parseInt(json.total || 0, 10));
      } else {
        addToast(json && json.mensaje ? json.mensaje : 'Error al listar asegurados', { appearance: 'error' });
      }
      setLoading(false);
    } catch (error) {
      addToast('Error, Recuperar Listar Asegurados', { appearance: 'error' });
      setLoading(false);
    }
  };

  const guardaAsegurado = async (asegurado) => {
    setLoading(true);
    var url = "" + urlCargarAseguradosExcelAP;
    var body = {
      id: id,
      asegurados: [asegurado]
    };
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' });
      const json = await response.json();
      if (json && json.transaccion) {
        addToast("Guardado con éxito", { appearance: 'success' });
        setCargaAsegurados(true);
      } else {
        addToast(json && json.mensaje ? json.mensaje : 'No se pudo guardar', { appearance: 'error' });
      }
      setLoading(false);
    } catch (error) {
      addToast('Error, Guardar asegurado', { appearance: 'error' });
      setLoading(false);
    }
  };

  /* ================= Acciones edición / eliminación ================= */
  function abrirModalEditar(aseg) {
    var asegId = safeGet(aseg && aseg.id, aseg && aseg._id);

    var planObj = (aseg && aseg.plan) ? aseg.plan : {};
    var planVal = safeGet(planObj.codigo, planObj.value, planObj._id);
    var planLabel = safeGet(planObj.nombre, planObj.label, (planVal ? String(planVal) : ''));

    var contratObj = (aseg && aseg.contratante) ? aseg.contratante : {};
    var contratVal = safeGet(contratObj.codigo, contratObj.value, contratObj._id);
    var contratLabel = safeGet(contratObj.nombreCompleto, contratObj.label, (contratVal ? String(contratVal) : ''));

    var fnac = safeGet(aseg && aseg.fecha_nacimiento);
    var nom = safeGet(aseg && aseg.nombre);
    var ident = safeGet(aseg && aseg.identificacion);

    var email = safeGet(aseg && aseg.email);
    var celular = safeGet(aseg && aseg.celular);
    var genero = safeGet(aseg && aseg.genero);
    var tipo_documento = safeGet(aseg && aseg.tipo_documento);

    var primerNombre = safeGet(aseg && aseg.primerNombre);
    var segundoNombre = safeGet(aseg && aseg.segundoNombre);
    var primerApellido = safeGet(aseg && aseg.primerApellido);
    var segundoApellido = safeGet(aseg && aseg.segundoApellido);

    var nombres = safeGet(aseg && aseg.nombres);
    if (!nombres && (primerNombre || segundoNombre)) {
      nombres = [primerNombre, segundoNombre].filter(Boolean).join(' ');
    }
    var apellidos = safeGet(aseg && aseg.apellidos);
    if (!apellidos && (primerApellido || segundoApellido)) {
      apellidos = [primerApellido, segundoApellido].filter(Boolean).join(' ');
    }

    setAseguradoEditId(asegId || '');
    setAseguradoEditDefaults({
      plan: planVal ? { value: String(planVal), label: planLabel || String(planVal) } : null,
      contratante: contratVal ? { value: String(contratVal), label: contratLabel || String(contratVal) } : null,
      nombre: nom || '',
      identificacion: ident || '',
      fecha_nacimiento: fnac || '',
      email: email || '',
      celular: celular || '',
      genero: genero || '',
      tipo_documento: tipo_documento || '',
      nombres: nombres || '',
      apellidos: apellidos || ''
    });
    setModalEditOpen(true);
  }

  async function editarAsegurado(aseguradoId, datosAct) {
    if (!aseguradoId && !(datosAct && datosAct.identificacion)) {
      addToast('Debe incluir aseguradoId o identificación para editar.', { appearance: 'warning' });
      return;
    }

    var datos = {
      plan: normalizeCodigo(datosAct && datosAct.plan),
      contratante: normalizeCodigo(datosAct && datosAct.contratante),
      nombre: safeGet(datosAct && datosAct.nombre),
      identificacion: safeGet(datosAct && datosAct.identificacion),
      fecha_nacimiento: safeGet(datosAct && datosAct.fecha_nacimiento),
      primerNombre: safeGet(datosAct && datosAct.primerNombre),
      segundoNombre: safeGet(datosAct && datosAct.segundoNombre),
      primerApellido: safeGet(datosAct && datosAct.primerApellido),
      segundoApellido: safeGet(datosAct && datosAct.segundoApellido),
      tipo_documento: safeGet(datosAct && datosAct.tipo_documento),
      email: safeGet(datosAct && datosAct.email),
      celular: safeGet(datosAct && datosAct.celular),
      genero: safeGet(datosAct && datosAct.genero)
    };

    Object.keys(datos).forEach(function (k) {
      if (datos[k] === '') delete datos[k];
    });

    if (!datos.nombre || !datos.identificacion) {
      addToast('Nombre e identificación son obligatorios.', { appearance: 'warning' });
      return;
    }

    setLoading(true);
    try {
      var payload = {
        slipId: id,
        aseguradoId: aseguradoId || undefined,
        identificacion: aseguradoId ? undefined : datos.identificacion,
        datos: datos
      };

      const response = await fetch(urlEditaAseguradoAP, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const json = await response.json();
      if (json && json.transaccion) {
        addToast('Asegurado actualizado', { appearance: 'success' });
        listarAsegurados();
      } else {
        addToast((json && json.mensaje) ? json.mensaje : 'No se pudo actualizar el asegurado', { appearance: 'error' });
      }
    } catch (e) {
      addToast('Error al actualizar el asegurado', { appearance: 'error' });
    }
    setLoading(false);
  }

  async function eliminarAsegurado(aseg) {
    var asegId = safeGet(aseg && aseg.id, aseg && aseg._id);
    var ident = safeGet(aseg && aseg.identificacion);

    if (!asegId && !ident) {
      addToast('No se pudo determinar el asegurado a eliminar (falta ID o identificación).', { appearance: 'warning' });
      return;
    }
    if (!window.confirm('¿Desea eliminar este asegurado?')) return;

    setLoading(true);
    try {
      var payload = {
        slipId: id,
        aseguradoId: asegId || undefined,
        identificacion: asegId ? undefined : ident
      };

      const response = await fetch(urlEliminaAseguradoAP, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const json = await response.json();
      if (json && json.transaccion) {
        addToast('Asegurado eliminado', { appearance: 'success' });
        listarAsegurados();
      } else {
        addToast((json && json.mensaje) ? json.mensaje : 'No se pudo eliminar el asegurado', { appearance: 'error' });
      }
    } catch (e) {
      addToast('Error al eliminar el asegurado', { appearance: 'error' });
    }
    setLoading(false);
  }

  /* ================= Derivados para el modal de códigos ================= */
  var planesListado = (Array.isArray(planes) ? planes : []).map(function (p) {
    return {
      codigo: normalizeCodigo(p),
      nombre: safeGet(p && p.nombre, p && p.label, '')
    };
  }).filter(function (x) { return x.codigo !== '' || x.nombre !== ''; });

  var pagadoresListado = (Array.isArray(pagadores) ? pagadores : []).map(function (c) {
    return {
      codigo: normalizeCodigo(c),
      nombre: safeGet(c && c.nombreCompleto, c && c.label, '')
    };
  }).filter(function (x) { return x.codigo !== '' || x.nombre !== ''; });

  // Filtros
  var filtroPlanLower = toLowerSafe(filtroPlan);
  var filtroPagLower = toLowerSafe(filtroPagador);

  var planesFiltrados = planesListado.filter(function (it) {
    return toLowerSafe(it.codigo).indexOf(filtroPlanLower) !== -1 ||
      toLowerSafe(it.nombre).indexOf(filtroPlanLower) !== -1;
  });
  var pagadoresFiltrados = pagadoresListado.filter(function (it) {
    return toLowerSafe(it.codigo).indexOf(filtroPagLower) !== -1 ||
      toLowerSafe(it.nombre).indexOf(filtroPagLower) !== -1;
  });

  return (
    <ContainerApFacturacion paso="vidas" titulo={props.datosCotizador.titulo}>
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={loading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Obteniendo datos..."
            >
              {blanket ? (
                <Card>
                  <CardBody>
                    <Row style={{ marginBottom: "20px", justifyContent: "center" }}>
                      <Col md="6">
                        <Row className="align-items-center mb-3">
                          <Col sm="12" md="6" className="mb-2 mb-md-0">
                            <label style={{ fontWeight: "bold", margin: 0 }}>Tipo de Facturación : </label>
                          </Col>
                          <Col sm="12" md="6">
                            <Select
                              value={tipoPago}
                              options={[tipoPago]}
                              isDisabled={true}
                              styles={{
                                container: function (base) { return { ...base, width: "100%" }; },
                                control: function (base) { return { ...base, borderColor: "#ced4da", minHeight: "38px", fontSize: "14px" }; },
                                singleValue: function (base) { return { ...base, color: "#495057" }; }
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="align-items-center mb-3">
                          <Col sm="12" md="6" className="mb-2 mb-md-0">
                            <label style={{ fontWeight: "bold", margin: 0 }}>Formas de pago</label>
                          </Col>
                          <Col sm="12" md="6">
                            <Select
                              value={formaPago}
                              options={formasPago}
                              onChange={function (e) { setFormaPago(e); }}
                              styles={{
                                container: function (base) { return { ...base, width: "100%" }; },
                                control: function (base) { return { ...base, borderColor: "#ced4da", minHeight: "38px", fontSize: "14px" }; },
                                singleValue: function (base) { return { ...base, color: "#495057" }; }
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="align-items-center mb-3">
                          <Col sm="12" md="6" className="mb-2 mb-md-0">
                            <label style={{ fontWeight: "bold", margin: 0 }}>Número de asegurados</label>
                          </Col>
                          <Col sm="12" md="6">
                            <input
                              type="text"
                              maxLength={7}
                              style={{
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                                minHeight: "38px",
                                fontSize: "14px",
                                padding: "5px 10px",
                                width: "100%",
                                color: "#495057",
                              }}
                              value={numeroAsegurados}
                              onChange={function (e) {
                                let val = e.target.value.replace(/\D/g, '');
                                // Remover ceros iniciales para asegurar que si es numérico sea > 0
                                val = val.replace(/^0+/, '');
                                setNumeroAsegurados(val);
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              ) : (
                <Card>
                  <CardBody>
                    <Row style={{ marginBottom: "20px", justifyContent: "center" }}>
                      <Col md="6">
                        <Row className="align-items-center mb-3">
                          <Col sm="12" md="6" className="mb-2 mb-md-0">
                            <label style={{ fontWeight: "bold", margin: 0 }}>Tipo de Facturación : </label>
                          </Col>
                          <Col sm="12" md="6">
                            <Select
                              value={tipoPago}
                              options={[tipoPago]}
                              isDisabled={true}
                              styles={{
                                container: function (base) { return { ...base, width: "100%" }; },
                                control: function (base) { return { ...base, borderColor: "#ced4da", minHeight: "38px", fontSize: "14px" }; },
                                singleValue: function (base) { return { ...base, color: "#495057" }; }
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="align-items-center mb-3">
                          <Col sm="12" md="6" className="mb-2 mb-md-0">
                            <label style={{ fontWeight: "bold", margin: 0 }}>Formas de pago</label>
                          </Col>
                          <Col sm="12" md="6">
                            <Select
                              value={formaPago}
                              options={formasPago}
                              onChange={function (e) { setFormaPago(e); }}
                              styles={{
                                container: function (base) { return { ...base, width: "100%" }; },
                                control: function (base) { return { ...base, borderColor: "#ced4da", minHeight: "38px", fontSize: "14px" }; },
                                singleValue: function (base) { return { ...base, color: "#495057" }; }
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {/* Título y botón agregar */}
                    <div style={{ marginBottom: "10px" }}>
                      <h5 style={{ fontWeight: "bold" }}>Lista de Vidas</h5>
                    </div>

                    {/* Botones de Excel */}
                    <div className="d-flex flex-wrap justify-content-end" style={{ marginBottom: "30px", gap: "10px" }}>
                      <Button
                        style={buttonStyle}
                        onClick={abrirModalCodigos}
                      >
                        <i className="fa fa-file-excel-o" /> DESCARGAR EXCEL
                      </Button>
                      <Button
                        style={{ ...buttonStyle, backgroundColor: "#ffffff", color: "#001871", border: "1px solid #001871" }}
                        onClick={handleButtonClick}
                      >
                        <i className="fa fa-upload" /> SUBIR EXCEL
                      </Button>
                      <input
                        type="file"
                        accept=".xlsx, .xls, .csv"
                        ref={fileInputRef}
                        onChange={subirPlantilla}
                        style={{ display: "none" }}
                      />
                      <Button style={buttonStyle} onClick={function () { setModalOpen(true); }}>
                        <i className="fa fa-plus" /> AGREGAR
                      </Button>
                    </div>

                    {/* Tabla */}
                    <Table bordered striped responsive>
                      <thead>
                        <tr>
                          <th style={tableHeaderStyle}>PLAN</th>
                          <th style={tableHeaderStyle}>CONTRATANTE</th>
                          <th style={tableHeaderStyle}>BROKER</th>
                          <th style={tableHeaderStyle}>MODALIDAD DE FACTURACION</th>
                          <th style={tableHeaderStyle}>FECHA DE FACTURACION</th>
                          <th style={tableHeaderStyle}>VIGENCIA DESDE</th>
                          <th style={tableHeaderStyle}>VIGENCIA HASTA</th>
                          <th style={tableHeaderStyle}>ASEGURADO</th>
                          <th style={tableHeaderStyle}>IDENTIFICACIÓN</th>
                          <th style={tableHeaderStyle}>ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        {asegurados.map(function (aseg, idx) {
                          var planName = get(aseg, ['plan', 'nombre'], get(aseg, ['plan', 'label'], ''));
                          var contrName = get(aseg, ['contratante', 'nombreCompleto'], get(aseg, ['contratante', 'label'], ''));
                          return (
                            <tr key={idx}>
                              <td>{planName}</td>
                              <td>{contrName}</td>
                              <td>{get(aseg, ['broker'], '')}</td>
                              <td>{get(aseg, ['modalidad_facturacion'], '')}</td>
                              <td>{get(aseg, ['fecha_facturacion'], '')}</td>
                              <td>{get(aseg, ['vigencia_desde'], '')}</td>
                              <td>{get(aseg, ['vigencia_hasta'], '')}</td>
                              <td>{get(aseg, ['nombre'], '')}</td>
                              <td>{get(aseg, ['identificacion'], '')}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>
                                <Button
                                  size="sm"
                                  color="warning"
                                  className="mr-2"
                                  onClick={function () { abrirModalEditar(aseg); }}
                                >
                                  <i className="fa fa-pencil" />
                                </Button>
                                <Button
                                  size="sm"
                                  color="danger"
                                  onClick={function () { eliminarAsegurado(aseg); }}
                                >
                                  <i className="fa fa-trash" />
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              )}

              {/* Botón regresar / continuar */}
              <Card style={{ marginTop: "20px" }}>
                <CardBody style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <Button
                    onClick={function () {
                      props.history.push({
                        pathname: props.datosCotizador.urlRegresar,
                        search: "?id=" + id,
                      });
                    }}
                    style={{ backgroundColor: "#001871", color: "white", border: "none" }}
                  >
                    <i className="fa fa-chevron-circle-left" /> &nbsp;REGRESAR
                  </Button>
                  <Button
                    onClick={guardarDatosVidas}
                    style={{ backgroundColor: "#001871", color: "white", border: "none" }}
                    disabled={!blanket && (!Array.isArray(asegurados) || asegurados.length === 0)}
                    title={!blanket && (!Array.isArray(asegurados) || asegurados.length === 0)
                      ? 'Debe agregar al menos un asegurado para continuar'
                      : ''}
                  >
                    CONTINUAR &nbsp;<i className="fa fa-chevron-circle-right" />
                  </Button>

                </CardBody>
              </Card>

              {/* Modal alta */}
              <Modal
                isOpen={modalOpen}
                toggle={function () { setModalOpen(!modalOpen); }}
                size="lg"
                centered
                style={{ maxWidth: "700px", margin: "auto" }}
              >
                <ModalHeader toggle={function () { setModalOpen(false); }}>Agregar Asegurado</ModalHeader>
                <ModalBody>
                  <FormularioAsegurado
                    planesOptions={planes}
                    contratantesOptions={pagadores}
                    onSubmit={handleAgregarAsegurado}
                    idCarrito={id}
                  />
                </ModalBody>
              </Modal>

              {/* Modal edición */}
              <Modal
                isOpen={modalEditOpen}
                toggle={function () { setModalEditOpen(!modalEditOpen); }}
                size="lg"
                centered
                style={{ maxWidth: "700px", margin: "auto" }}
              >
                <ModalHeader toggle={function () { setModalEditOpen(false); }}>Editar Asegurado</ModalHeader>
                <ModalBody>
                  <FormularioAsegurado
                    planesOptions={planes}
                    contratantesOptions={pagadores}
                    onSubmit={handleEditarAsegurado}
                    defaultValues={aseguradoEditDefaults}
                    modoEdicion={true}
                    idCarrito={id}
                  />
                </ModalBody>
              </Modal>

              {/* ========= MODAL DE CÓDIGOS (nuevo) ========= */}
              <Modal
                isOpen={codigosModalOpen}
                toggle={function () { setCodigosModalOpen(!codigosModalOpen); }}
                size="lg"
                centered
                style={{ maxWidth: "900px", margin: "auto" }}
              >
                <ModalHeader toggle={function () { setCodigosModalOpen(false); }}>
                  Códigos para completar la plantilla
                </ModalHeader>
                <ModalBody>
                  <p className="text-muted" style={{ marginBottom: 16 }}>
                    Usa estos <b>códigos de Plan</b> y <b>códigos de Pagador</b> para rellenar correctamente las columnas del Excel.
                  </p>

                  <Row>
                    <Col md="6" style={{ marginBottom: 20 }}>
                      <h6 style={{ fontWeight: 'bold' }}>Planes</h6>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar por código o nombre..."
                        value={filtroPlan}
                        onChange={function (e) { setFiltroPlan(e.target.value); }}
                        style={{ marginBottom: 8 }}
                      />
                      <Table bordered size="sm" responsive>
                        <thead>
                          <tr>
                            <th style={tableHeaderStyle}>CÓDIGO</th>
                            <th style={tableHeaderStyle}>NOMBRE</th>
                          </tr>
                        </thead>
                        <tbody>
                          {planesFiltrados.length > 0 ? planesFiltrados.map(function (pl, idx) {
                            return (
                              <tr key={'pl-' + idx}>
                                <td>{pl.codigo}</td>
                                <td>{pl.nombre}</td>
                              </tr>
                            );
                          }) : (
                            <tr><td colSpan="2" className="text-center text-muted">Sin resultados</td></tr>
                          )}
                        </tbody>
                      </Table>
                    </Col>

                    <Col md="6" style={{ marginBottom: 20 }}>
                      <h6 style={{ fontWeight: 'bold' }}>Pagadores</h6>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar por código o nombre..."
                        value={filtroPagador}
                        onChange={function (e) { setFiltroPagador(e.target.value); }}
                        style={{ marginBottom: 8 }}
                      />
                      <Table bordered size="sm" responsive>
                        <thead>
                          <tr>
                            <th style={tableHeaderStyle}>CÓDIGO</th>
                            <th style={tableHeaderStyle}>NOMBRE</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagadoresFiltrados.length > 0 ? pagadoresFiltrados.map(function (pg, idx) {
                            return (
                              <tr key={'pg-' + idx}>
                                <td>{pg.codigo}</td>
                                <td>{pg.nombre}</td>
                              </tr>
                            );
                          }) : (
                            <tr><td colSpan="2" className="text-center text-muted">Sin resultados</td></tr>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <Button
                    style={{ ...buttonStyle }}
                    onClick={descargarPlantilla}
                  >
                    <i className="fa fa-download" /> Descargar plantilla
                  </Button>
                  <Button color="secondary" onClick={function () { setCodigosModalOpen(false); }}>
                    Cerrar
                  </Button>
                </ModalFooter>
              </Modal>
              {/* ========= FIN MODAL DE CÓDIGOS ========= */}

              {/* ========= MODAL RESULTADO DE CARGA ========= */}
              <Modal
                isOpen={!!resultadoCarga}
                toggle={cerrarResultado}
                size="xl"
                centered
                style={{ maxWidth: "950px", margin: "auto" }}
              >
                <ModalHeader toggle={cerrarResultado}>
                  <i className="fa fa-file-excel-o" style={{ marginRight: 8 }} />
                  Resultado de Carga de Excel
                </ModalHeader>
                <ModalBody>
                  {resultadoCarga && (
                    <div>
                      {/* Badges de resumen */}
                      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
                        <span style={{
                          padding: '6px 14px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold',
                          backgroundColor: '#e9ecef', color: '#495057'
                        }}>
                          Total: {resultadoCarga.total}
                        </span>
                        <span style={{
                          padding: '6px 14px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold',
                          backgroundColor: '#d4edda', color: '#155724'
                        }}>
                          ✅ Agregados: {resultadoCarga.agregados}
                        </span>
                        <span style={{
                          padding: '6px 14px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold',
                          backgroundColor: '#f8d7da', color: '#721c24'
                        }}>
                          ❌ Rechazados: {resultadoCarga.rechazados}
                        </span>
                      </div>

                      {/* Tabla de detalle */}
                      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <Table bordered size="sm" responsive>
                          <thead>
                            <tr>
                              <th style={{ ...tableHeaderStyle, fontSize: '12px' }}>#</th>
                              <th style={{ ...tableHeaderStyle, fontSize: '12px' }}>IDENTIFICACIÓN</th>
                              <th style={{ ...tableHeaderStyle, fontSize: '12px' }}>ASEGURADO</th>
                              <th style={{ ...tableHeaderStyle, fontSize: '12px' }}>PLAN</th>
                              <th style={{ ...tableHeaderStyle, fontSize: '12px' }}>ESTADO</th>
                              <th style={{ ...tableHeaderStyle, fontSize: '12px' }}>MOTIVO</th>
                            </tr>
                          </thead>
                          <tbody>
                            {resultadoCarga.detalle.map(function (item, idx) {
                              return (
                                <tr key={idx} style={{
                                  backgroundColor: item.exitoso ? '#d4edda' : '#f8d7da',
                                  fontSize: '13px'
                                }}>
                                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>{idx + 1}</td>
                                  <td>{item.identificacion}</td>
                                  <td>{item.nombre}</td>
                                  <td style={{ fontSize: '11px', wordBreak: 'break-all' }}>{item.plan}</td>
                                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {item.exitoso
                                      ? <span style={{ color: '#155724' }}>✅ Agregado</span>
                                      : <span style={{ color: '#721c24' }}>❌ Rechazado</span>
                                    }
                                  </td>
                                  <td style={{ fontSize: '12px', color: item.exitoso ? '#155724' : '#721c24' }}>
                                    {item.motivo || '—'}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                </ModalBody>
                <ModalFooter>
                  <Button style={buttonStyle} onClick={cerrarResultado}>
                    Cerrar
                  </Button>
                </ModalFooter>
              </Modal>
              {/* ========= FIN MODAL RESULTADO ========= */}

            </LoadingScreen>
          </div>
        </div>
      </main>
    </ContainerApFacturacion>
  );
};

export default ComponentApFacturacionVidas;
